import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


jQuery(document).ready(function () {
    // const singleGalleryPost = jQuery('.single__holder .photo-gallery').length > 0;

    const singleGalleryPost = jQuery('.single__holder .photo-gallery').length > 0;
    if (jQuery('.single').length > 0 && singleGalleryPost){

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    // Get the image element
                    const img = entry.target;
                    
                    // Check if animation has already played
                    if (img.dataset.animated === 'true') {
                        // Keep full opacity and scale when already animated
                        img.style.opacity = '1';
                        img.style.transform = 'scale(1)';
                        return;
                    }

                    if (entry.isIntersecting) {
                        // Calculate how far into view the element is
                        const ratio = entry.intersectionRatio;
                        // Apply transforms based on scroll position
                        img.style.opacity = ratio.toString();
                        img.style.transform = `scale(${0.8 + (ratio * 0.2)})`;
                        
                        // Mark as animated when fully visible
                        if (ratio >= 0.99) {
                            img.dataset.animated = 'true';
                        }
                    } else if (entry.boundingClientRect.top < 0) {
                        // If the image is leaving the viewport from the top, keep it at full opacity and scale
                        img.style.opacity = '1';
                        img.style.transform = 'scale(1)';
                        img.dataset.animated = 'true';
                    }
                });
            }, {
                // Use multiple thresholds for smoother animation
                threshold: Array.from({ length: 100 }, (_, i) => i / 100)
            });

        // Add data-fancybox attribute and accessibility features to all content images
        jQuery(' .content img').each(function () {
            const $img = jQuery(this);

                // if(!singleGalleryPost){
            // Add initial styles
                $img.css({
                    'opacity': '0',
                    'transform': 'scale(0.8)',
                    'transition': 'opacity 0.2s ease, transform 0.2s ease'
                });
            //  }
            
            // Initialize animation state
            this.dataset.animated = 'false';
            
            // Start observing each image
            // if(!singleGalleryPost){
                observer.observe(this);
            // }

            // Add gallery group name
            $img.attr('data-fancybox', 'gallery');

            // Add tabindex and role for accessibility
            $img.attr('tabindex', '0');
            $img.attr('role', 'button');
            $img.attr('aria-label', 'Open image in gallery');

            // Find caption if exists and store it as data attribute
            const figure = $img.closest('figure');
            if (figure.length) {
                const figcaption = figure.find('figcaption').html();
                if (figcaption) {
                    $img.attr('data-caption', figcaption);
                    // Update aria-label to include caption
                    $img.attr('aria-label', `Open image in gallery: ${figcaption.replace(/<[^>]*>/g, '')}`);
                }
            }

            // Add keyboard event listener for Enter and Space keys
            $img.on('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    // Trigger click on the image to open gallery with all images
                    this.click();
                }
            });
        });

        // Initialize Fancybox
        Fancybox.bind("[data-fancybox]", {
            groupAll: true,
            keyboard: {
                Escape: "close",
                Delete: "close",
                Backspace: "close",
                PageUp: "next",
                PageDown: "prev",
                ArrowUp: "next",
                ArrowDown: "prev",
                ArrowRight: "next",
                ArrowLeft: "prev",
            },
            Images: {
                Panzoom: {
                    maxScale: 0.9,
                },
                initialSize: "fit"
            },
            Toolbar: {
                display: {
                    // left: [],
                    middle: [],
                    right: ["close"]
                }
            }
        });
    };
});
